import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import styles from './sellerregispageblock2.module.css';
import axios from 'axios';
import { useTranslation } from "react-i18next";

const SellerRegisPageBlock2 = ({ onBack, onNext, updateData, formData }) => {
  const [businessType, setBusinessType] = useState(formData.businessType || '');
  const [email, setEmail] = useState(formData.email || '');
  const [taxCode, setTaxCode] = useState(formData.taxCode || '');
  const [cities, setCities] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [wards, setWards] = useState([]);
  const [selectedCity, setSelectedCity] = useState(formData.selectedCity || '');
  const [selectedDistrict, setSelectedDistrict] = useState(formData.selectedDistrict || '');
  const [selectedWard, setSelectedWard] = useState(formData.selectedWard || '');
  const [selectedCityName, setSelectedCityName] = useState(formData.selectedCityName || '');
  const [selectedDistrictName, setSelectedDistrictName] = useState(formData.selectedDistrictName || '');
  const [selectedWardName, setSelectedWardName] = useState(formData.selectedWardName || '');
  const [errorMessage, setErrorMessage] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    axios.get("https://raw.githubusercontent.com/kenzouno1/DiaGioiHanhChinhVN/master/data.json")
      .then((response) => {
        setCities(response.data);

        // Update districts and wards if formData contains selected city and district
        if (selectedCity) {
          const city = response.data.find((city) => city.Id === selectedCity);
          if (city) {
            setDistricts(city.Districts);
            if (selectedDistrict) {
              const district = city.Districts.find((district) => district.Id === selectedDistrict);
              if (district) {
                setWards(district.Wards);
              }
            }
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching cities:", error);
      });
  }, [selectedCity]);

  useEffect(() => {
    if (selectedCity) {
      const city = cities.find((city) => city.Id === selectedCity);
      if (city) {
        setDistricts(city.Districts);
      }
    } else {
      setDistricts([]);
      setWards([]);
    }
  }, [selectedCity, cities]);

  useEffect(() => {
    if (selectedDistrict) {
      const city = cities.find((city) => city.Id === selectedCity);
      if (city) {
        const district = city.Districts.find((district) => district.Id === selectedDistrict);
        if (district) {
          setWards(district.Wards);
        }
      }
    } else {
      setWards([]);
    }
  }, [selectedDistrict, cities, selectedCity]);

  const handleCityChange = (event) => {
    const cityId = event.target.value;
    const cityName = event.target.options[event.target.selectedIndex].text;
    setSelectedCity(cityId);
    setSelectedCityName(cityName);
    setSelectedDistrict('');
    setSelectedWard('');
  };

  const handleDistrictChange = (event) => {
    const districtId = event.target.value;
    const districtName = event.target.options[event.target.selectedIndex].text;
    setSelectedDistrict(districtId);
    setSelectedDistrictName(districtName);
    setSelectedWard('');
  };

  const handleWardChange = (event) => {
    const wardId = event.target.value;
    const wardName = event.target.options[event.target.selectedIndex].text;
    setSelectedWard(wardId);
    setSelectedWardName(wardName);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateTaxCode = (taxCode) => {
    const taxCodeRegex = /^\d{10,13}$/;
    return taxCodeRegex.test(taxCode);
  };

  const handleNext = () => {
    if (!businessType || !email || !taxCode || !selectedCity || !selectedDistrict || !selectedWard) {
      setErrorMessage(t("fill_all_data"));
      return;
    }
    if (!validateEmail(email)) {
      setErrorMessage(t("error_email"));
      return;
    }
    if (!validateTaxCode(taxCode)) {
      setErrorMessage(t("error_tax"));
      return;
    }
    updateData({
      businessType,
      email,
      taxCode,
      selectedCity,
      selectedCityName,
      selectedDistrict,
      selectedDistrictName,
      selectedWard,
      selectedWardName,
    });
    setErrorMessage('');
    onNext();
  };

  return (
    <div className={styles["block-container"]}>
      {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
      <div className="mb-3 row align-items-center">
        <label htmlFor="businessType" className="col-sm-2 col-form-label">{t("business_type")}</label>
        <div className="col-sm-10 d-flex">
          <div className="form-check me-3">
            <input
              className={`form-check-input ${styles.formCheck}`}
              type="radio"
              name="businessType"
              id="businessType1"
              value="Cá nhân"
              checked={businessType === 'Cá nhân'}
              onChange={() => setBusinessType('Cá nhân')}
            />
            <label className="form-check-label" htmlFor="businessType1">
              {t("individual")}
            </label>
          </div>
          <div className="form-check me-3">
            <input
              className={`form-check-input ${styles.formCheck}`}
              type="radio"
              name="businessType"
              id="businessType2"
              value="Hộ kinh doanh"
              checked={businessType === 'Hộ kinh doanh'}
              onChange={() => setBusinessType('Hộ kinh doanh')}
            />
            <label className="form-check-label" htmlFor="businessType2">
              {t("household_business")}
            </label>
          </div>
          <div className="form-check me-3">
            <input
              className={`form-check-input ${styles.formCheck}`}
              type="radio"
              name="businessType"
              id="businessType3"
              value="Công ty"
              checked={businessType === 'Công ty'}
              onChange={() => setBusinessType('Công ty')}
            />
            <label className="form-check-label" htmlFor="businessType3">
              {t("company")}
            </label>
          </div>
        </div>
      </div>

      <div className="mb-3 row">
        <label htmlFor="city" className="col-sm-2 col-form-label">{t("business_address")}</label>
        <div className="col-sm-10 d-flex">
          <div className="col-sm-4 me-2">
            <select
              className="form-select"
              id="city"
              aria-label="Chọn tỉnh thành"
              value={selectedCity}
              onChange={handleCityChange}
            >
              <option value="">{t("city")}</option>
              {cities.map((city) => (
                <option key={city.Id} value={city.Id}>{city.Name}</option>
              ))}
            </select>
          </div>
          <div className="col-sm-4 me-2">
            <select
              className="form-select"
              id="district"
              aria-label="Chọn quận huyện"
              value={selectedDistrict}
              onChange={handleDistrictChange}
              disabled={!selectedCity}
            >
              <option value="">{t("district")}</option>
              {districts.map((district) => (
                <option key={district.Id} value={district.Id}>{district.Name}</option>
              ))}
            </select>
          </div>
          <div className="col-sm-4">
            <select
              className="form-select"
              id="ward"
              aria-label="Chọn phường xã"
              value={selectedWard}
              onChange={handleWardChange}
              disabled={!selectedDistrict}
            >
              <option value="">{t("ward")}</option>
              {wards.map((ward) => (
                <option key={ward.Id} value={ward.Id}>{ward.Name}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="email" className="col-sm-2 col-form-label">{t("electronic_invoice_email")}</label>
        <div className="col-sm-10">
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Điền địa chỉ Email"
            className="form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
      </div>

      <div className="mb-3 row">
        <label htmlFor="taxCode" className="col-sm-2 col-form-label">{t("tax_code")}</label>
        <div className="col-sm-10">
          <input
            type="text"
            id="taxCode"
            name="taxCode"
            placeholder="Điền mã số thuế"
            className="form-control"
            value={taxCode}
            onChange={(e) => setTaxCode(e.target.value)}
          />
        </div>
      </div>

      <div className="d-flex justify-content-between">
        <button type="button" className="btn btn-success" onClick={onBack}>{t("comeback")}</button>
        <button type="button" className="btn btn-primary" onClick={handleNext}>{t("next")}</button>
      </div>
    </div>
  );
};

export default SellerRegisPageBlock2;
